/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Coordinate } from "./Coordinate";
import {
  CoordinateFromJSON,
  CoordinateFromJSONTyped,
  CoordinateToJSON,
  CoordinateToJSONTyped,
} from "./Coordinate";
import type { ShapeFormat } from "./ShapeFormat";
import {
  ShapeFormatFromJSON,
  ShapeFormatFromJSONTyped,
  ShapeFormatToJSON,
  ShapeFormatToJSONTyped,
} from "./ShapeFormat";

/**
 * Request body for the elevation endpoint.
 * @export
 * @interface HeightRequest
 */
export interface HeightRequest {
  /**
   * An identifier to disambiguate requests (echoed by the server).
   * @type {string}
   * @memberof HeightRequest
   */
  id?: string | null;
  /**
   * The path to get the height along, expressed as a sequence of coordinates.
   *
   * REQUIRED if `encoded_polyline` is not present.
   * @type {Array<Coordinate>}
   * @memberof HeightRequest
   */
  shape?: Array<Coordinate> | null;
  /**
   * An [encoded polyline string](https://developers.google.com/maps/documentation/utilities/polylinealgorithm).
   *
   * REQUIRED if `shape` is not present.
   * @type {string}
   * @memberof HeightRequest
   */
  encodedPolyline?: string | null;
  /**
   * Specifies whether the polyline is encoded with 6 digit precision (polyline6) or 5 digit precision (polyline5).
   * @type {ShapeFormat}
   * @memberof HeightRequest
   */
  shapeFormat?: ShapeFormat;
  /**
   * Controls whether the returned array is one-dimensional (height only) or two-dimensional (with a range and height).
   * The range dimension can be used to generate a graph or steepness gradient along a route.
   * @type {boolean}
   * @memberof HeightRequest
   */
  range?: boolean;
  /**
   * The decimal precision (number of digits after the point) of the output.
   * @type {number}
   * @memberof HeightRequest
   */
  heightPrecision?: number | null;
  /**
   * The distance at which the input polyline should be sampled to provide uniform distances between points.
   * If not set, the input shape will be used as-is.
   * @type {number}
   * @memberof HeightRequest
   */
  resampleDistance?: number | null;
}

/**
 * Check if a given object implements the HeightRequest interface.
 */
export function instanceOfHeightRequest(value: object): value is HeightRequest {
  return true;
}

export function HeightRequestFromJSON(json: any): HeightRequest {
  return HeightRequestFromJSONTyped(json, false);
}

export function HeightRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HeightRequest {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    shape:
      json["shape"] == null
        ? undefined
        : (json["shape"] as Array<any>).map(CoordinateFromJSON),
    encodedPolyline:
      json["encoded_polyline"] == null ? undefined : json["encoded_polyline"],
    shapeFormat:
      json["shape_format"] == null
        ? undefined
        : ShapeFormatFromJSON(json["shape_format"]),
    range: json["range"] == null ? undefined : json["range"],
    heightPrecision:
      json["height_precision"] == null ? undefined : json["height_precision"],
    resampleDistance:
      json["resample_distance"] == null ? undefined : json["resample_distance"],
  };
}

export function HeightRequestToJSON(json: any): HeightRequest {
  return HeightRequestToJSONTyped(json, false);
}

export function HeightRequestToJSONTyped(
  value?: HeightRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    shape:
      value["shape"] == null
        ? undefined
        : (value["shape"] as Array<any>).map(CoordinateToJSON),
    encoded_polyline: value["encodedPolyline"],
    shape_format: ShapeFormatToJSON(value["shapeFormat"]),
    range: value["range"],
    height_precision: value["heightPrecision"],
    resample_distance: value["resampleDistance"],
  };
}
